import { Input } from "@chakra-ui/react";
import { nb } from "date-fns/locale/nb";
import { forwardRef, useEffect } from "react";
import { registerLocale, setDefaultLocale } from "react-datepicker";

registerLocale("nb", nb);
setDefaultLocale("nb");

export const PORTAL_ID = "datepicker-portal";

export const datepickerLocaleMap: Record<string, string> = {
  no: "nb-NO",
  en: "en-US",
};

export const PickerCustomInput = forwardRef<
  HTMLInputElement,
  React.ComponentProps<typeof Input>
>((props, ref) => (
  <Input
    ref={ref}
    {...props}
    fontSize="md"
    maxWidth={{ sm: "full", md: "60" }}
    border="1px solid"
    borderColor="smBorder"
    backgroundColor="smBackground"
    rounded="md"
    p="4"
    readOnly
    cursor="pointer"
  />
));
PickerCustomInput.displayName = "PickerCustomInput";

export const parsePickerIsoDate = (
  iso: string | null | undefined,
  options: { warnOnInvalid?: boolean } = {},
): Date | null => {
  if (!iso) return null;
  const d = new Date(iso);
  if (!isNaN(d.getTime())) return d;
  if (options.warnOnInvalid) {
    // eslint-disable-next-line no-console
    console.warn("Datepicker received an unparseable ISO string", { iso });
  }
  return null;
};

export const useDatepickerPortal = (): void => {
  useEffect(() => {
    if (!document.getElementById(PORTAL_ID)) {
      const el = document.createElement("div");
      el.id = PORTAL_ID;
      document.body.appendChild(el);
    }
  }, []);
};
